import { ROUTES_APLICATION } from "@constants/routes-aplication.constants";
import { ApplicationModules } from "@core/enums/application-modules.enum";
import { UserTypeEnum } from "@core/enums/user-type.enum";
import { MenuConfigModel } from "@core/models/outros/menu-config.model";


export const MENU_LOG: MenuConfigModel = {
    id: ApplicationModules.LOG,
    icon: 'manage_accounts',
    name: 'log',
    onlyAssociated: true,
    text: 'Aqui você pode verificar os <strong>logs de transações </strong> das APIs.',
    profilesToShowItems: [
      UserTypeEnum.ADMINISTRADOR,
      UserTypeEnum.SUPERVISOR
    ],
    submenus: [
      {
        name: 'Agendamento',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.scheduling}`,
      },
      {
        name: 'Agendamento de Candidatos',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.candidateScheduling}`,
      },
      {
        name: 'CFC',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.cfc}`,
      },
      {
        name: 'Grade',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.grid}`,
      },
      {
        name: 'Instrutor',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.instructor}`,
      },
      {
        name: 'Matrícula',
        onlyAssociated: true,
        profilesToShowItems: [
          UserTypeEnum.ADMINISTRADOR
        ],
        route: `/${ROUTES_APLICATION.log.path}/${ROUTES_APLICATION.log.registration}`,
      },
    ],
  }